import { createSlice } from '@reduxjs/toolkit';

export const EmployeeSlice = createSlice({
    name: 'employee',
    initialState: {
        employee_list: [],
        employee: {},
        employee_select: []
    },
    reducers: {
        setEmployesRedux: ( state, { payload } ) => {
            state.employee_list  =  payload;
        },
        setEmployeRedux: ( state, { payload } ) => {
            state.employee  =  payload;
        },
        setEmployeSelectRedux: ( state, { payload } ) => {
            state.employee_select  =  payload;
        }        
        
    }
});


// Action creators are generated for each case reducer function
export const { setEmployesRedux, setEmployeRedux, setEmployeSelectRedux } = EmployeeSlice.actions;